import PartialsManager, { PartialsEvents } from 'assets/core/js/module/partialsManager'

export const PartialsLoadingEvents = {
  SHOW: 'dca.partial.loading-show',
  HIDE: 'dca.partial.loading-hide',
  VISIBLE: 'dca.partial.loading-visible',
  HIDDEN: 'dca.partial.loading-hidden',
}

export const HIDE_LOADING_TIMEOUT = 500

export default function (): void {
  if (window.partialsConfig) {
    for (const context in window.partialsConfig) {
      const ids = window.partialsConfig[context]?.ids.split(',') || []

      const config: { url: string; partials: Record<string, HTMLElement> } = {
        url: window.partialsConfig[context]?.url as string,
        partials: {},
      }

      ids.forEach((id) => {
        const partialEl = document.querySelector<HTMLElement>(`[data-partial-id="${id}"]`)

        if (partialEl) {
          config.partials[id] = partialEl
          partialEl.classList.add('dca-partials__block')

          const showLoading = (e: Event): void => {
            const target = e.target as HTMLElement
            const loaderEl = document.querySelector(`[data-partial-id="${id}"] .dca-partials__loading`)

            target.classList.add('dca-partials__block--loading')

            if (loaderEl) {
              loaderEl.classList.add('partial__loading--visible')

              partialEl.dispatchEvent(new CustomEvent(PartialsLoadingEvents.VISIBLE))
            }
          }

          const hideLoading = (e: Event): void => {
            const target = e.target as HTMLElement
            // we need to set a 0.5s timeout or the loading will be too fast for the client to see that something happened
            window.setTimeout(() => {
              const loaderEl = document.querySelector(`[data-partial-id="${id}"] .dca-partials__loading`)

              target.classList.remove('dca-partials__block--loading')

              if (loaderEl) {
                loaderEl.classList.remove('partial__loading--visible')

                partialEl.dispatchEvent(new CustomEvent(PartialsLoadingEvents.HIDDEN))
              }
            }, HIDE_LOADING_TIMEOUT)
          }

          partialEl.addEventListener(PartialsLoadingEvents.SHOW, showLoading)
          partialEl.addEventListener(PartialsLoadingEvents.HIDE, hideLoading)
          partialEl.addEventListener(PartialsEvents.PRE_UPDATE, showLoading)
          partialEl.addEventListener(PartialsEvents.POST_UPDATE, hideLoading)
          partialEl.addEventListener(PartialsEvents.ERROR_UPDATE, hideLoading)
        }
      })

      PartialsManager.init(context, config.partials, {
        type: 'url',
        url: config.url,
      })
    }
  }
}
